import React, { useState } from 'react';
import { Container } from "./styles";
import { FiDownload } from "react-icons/fi";
import { GoFile } from "react-icons/go";
import { BiSpreadsheet } from "react-icons/bi";
import XmlDownload from "../xml-download";
import SpedDownload from "../sped-download";

export default function Downloads() {
  const [activeTab, setActiveTab] = useState('xml'); // 'xml' ou 'sped'

  return (
    <Container>
      {/* Header */}
      <div className="header-info">
        <div className="header-icon">
          <FiDownload />
        </div>
        <div className="header-details">
          <h3>{activeTab === 'xml' ? 'Download de XMLs' : 'Download de SPEDs'}</h3>
          <div className="header-meta">
            <span className="status-tag active">Sistema Ativo</span>
          </div>
        </div>
      </div>

      {/* Tabs Toggle - XML's (verde) e SPED's (azul) */}
      <div className="tabs-header">
        <button 
          className={`tab ${activeTab === 'xml' ? 'active-xml' : ''}`}
          onClick={() => setActiveTab('xml')}
        >
          <GoFile />
          XML's
        </button>
        <button 
          className={`tab ${activeTab === 'sped' ? 'active-sped' : ''}`}
          onClick={() => setActiveTab('sped')}
        >
          <BiSpreadsheet />
          SPED's
        </button>
      </div>

      {/* Conteúdo da aba ativa */}
      <div className="embedded-content">
        {activeTab === 'xml' ? (
          <XmlDownload embedded />
        ) : (
          <SpedDownload embedded />
        )}
      </div>
    </Container>
  );
}
